import IntegrationsTab from './IntegrationsTab';

export default IntegrationsTab;
